import { render, staticRenderFns } from "./CadDent.vue?vue&type=template&id=75d506b5&"
import script from "./CadDent.vue?vue&type=script&lang=js&"
export * from "./CadDent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports